import { render, staticRenderFns } from "./affirm.vue?vue&type=template&id=7d289a5c&scoped=true&"
import script from "./affirm.vue?vue&type=script&lang=js&"
export * from "./affirm.vue?vue&type=script&lang=js&"
import style0 from "./affirm.vue?vue&type=style&index=0&id=7d289a5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d289a5c",
  null
  
)

export default component.exports